import deepmerge from "deepmerge";
import cloneDeep from "lodash/cloneDeep";
import { v4 as uuidv4 } from "uuid";
import Base58 from "base-58";
import { UPDATE_ENTITY_ACTIONS } from "../Common/constants";

export function getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale }) {
  let ModuleTranslation = ModuleTranslations.default;
  if (locale && ModuleTranslations.hasOwnProperty(locale)) {
    ModuleTranslation = ModuleTranslations[locale];
  }
  const mergeField = prop => dataField => {
    const translatedField = ModuleTranslation.fields[prop].find(
      translatedField => dataField.fieldName === translatedField.fieldName
    );
    return { ...dataField, ...translatedField };
  };

  const translated = cloneDeep(ModuleTranslation);
  const original = cloneDeep(ModuleDefinition);

  translated.fields.form = original.fields.form.map(mergeField("form"));
  translated.fields.list = original.fields.list.map(mergeField("list"));
  if (translated.validation) {
    Object.keys(original.validation).forEach(key => {
      return (translated.validation[key] = {
        ...original.validation[key],
        ...translated.validation[key],
      });
    });
  }

  // This checks if tabs have translated titles and/or if have different
  // titles for creating or editing entity
  if (original.tabs) {
    translated.tabs = original.tabs.map((tab, indexTab) => {
      const translation = ModuleTranslation.tabs[indexTab];
      return {
        ...tab,
        ...translation,
      };
    });

    original.tabs = [];
  }

  original.fields.form = [];
  original.fields.list = [];

  return deepmerge(original, translated);
}

export function updateObjectByPath({ action, object, path, value }) {
  path = path.split(".");

  let i = 0;
  for (i; i < path.length - 1; i++) {
    object = object && object[path[i]];
  }

  if (object) {
    switch (action) {
      case UPDATE_ENTITY_ACTIONS.REPLACE:
        object[path[i]] = value;
        break;

      case UPDATE_ENTITY_ACTIONS.ADD:
        object[path[i]].push(value);
        break;

      case UPDATE_ENTITY_ACTIONS.DELETE:
        object.splice(path[i], 1);
        break;
      default:
        break;
    }
  }
}

export function generateBase58uuid() {
  return Base58.encode(uuidv4()).substr(0, 21);
}
